import { createAction } from '@reduxjs/toolkit';
import {
  NotificationT,
  NotificationUpdatePayload,
} from 'lib-shared-legacy-types';
import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const notificationActions = Object.assign(
  createActions(
    {
      NOTIFICATION_DESKTOP_PERMISSION: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      NOTIFICATION_GET_PERSISTED: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
      NOTIFICATION_GET_FAILED_BULK_ACTIONS: [
        (payload: any) => payload, // Payload
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
      ],
    },

    'NOTIFICATION_DESKTOP_PERMISSION_SUCCEEDED',
    'NOTIFICATION_DESKTOP_PERMISSION_FAILED',

    'NOTIFICATION_GET_FAILED_BULK_ACTIONS_SUCCEEDED',
    'NOTIFICATION_GET_FAILED_BULK_ACTIONS_FAILED',

    'NOTIFICATION_DESKTOP_ADD',

    'NOTIFICATION_ADD',
    'NOTIFICATION_ADDED',
    'NOTIFICATION_REMOVE_BY_ID',
    'NOTIFICATION_REMOVE_IN_STATE_BY_ID',
    'NOTIFICATION_REMOVE_ALL_BY_ID',
    'NOTIFICATION_REMOVE_BY_TYPE',
    'NOTIFICATION_REMOVE_IN_STATE_BY_TYPE',

    'NOTIFICATION_RATING_ADDED',

    'NOTIFICATION_HISTORY_RESET',
    'NOTIFICATION_HISTORY_INCREASE_DOT',
    'NOTIFICATION_HISTORY_RESET_DOT',
    'NOTIFICATION_HISTORY_TOGGLE_DROPDOWN',
    'NOTIFICATION_HISTORY_CLOSE_DROPDOWN',

    'NOTIFICATION_FAVICON_CHANGE',
    'NOTIFICATION_FAVICON_RESET',

    'NOTIFICATION_SOUND_PLAY',

    'NOTIFICATION_DROPDOWN_OPEN',
    'NOTIFICATION_DROPDOWN_CLOSE',

    'NOTIFICATION_TAB_BADGE_SHOW',
    'NOTIFICATION_TAB_BADGE_RESET',

    'NOTIFICATION_SOUNDS_INIT',
  ),
  {
    notificationUpdate: createAction<NotificationUpdatePayload>(
      'notification/update',
    ),
    notificationHistoryRemove: createAction<{ id: NotificationT['id'] }>(
      'notification/historyRemove',
    ),
  },
);
